import React from "react";
import Loader from "../../assets/img/loader.gif";

const Modal = ({
  isOpen,
  onClose,
  isActive,
  onToggle,
  activateRef,
  confirmLoader,
  name,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div
        className="w-96 rounded-xl bg-navy-800 p-6 shadow-lg"
        ref={activateRef}
      >
        <h2 className="mb-4 text-xl font-bold text-white">Confirm Action</h2>
        <p className="mb-6 text-gray-600">
          Are you sure you want to{" "}
          {name === "active"
            ? isActive
              ? "In active this user?"
              : "active this user?"
            : isActive === 0
            ? "turn this user to free?"
            : "turn this user to premium?"}{" "}
        </p>
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={onClose}
            disabled={confirmLoader}
            className="px-5 py-2.5 rounded-lg bg-white/10 text-white hover:bg-white/20 transition-all duration-200 font-semibold text-sm border border-white/20 disabled:pointer-events-none disabled:opacity-40"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              onToggle();
            }}
            disabled={confirmLoader}
            className="w-24 rounded-md bg-orangePrimary px-4 py-2 text-white hover:opacity-90 disabled:opacity-90"
          >
            {confirmLoader ? (
              <img src={Loader} alt="Loading..." className="mx-auto h-6 w-6" />
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
